import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';

import { attachmentExceptionOptions } from 'bundles/apex/tasks/helpers';
import Attachments from 'bundles/backoffice/attachments';
import { Button } from 'components/ui/button';
import Modal from 'components/modal';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedRadioGroup from 'components/form/managed_input/radio_group';

export default function AttachmentModal({
  addTaskAttachment,
  attachmentExceptions,
  attachmentsPath,
  canDeleteAttachments,
  deleteTaskAttachment,
  forUserId,
  show,
  task,
  onHide,
  onSave,
}) {
  const [attachmentException, setAttachmentException] = useState();
  const [exceptionReason, setExceptionReason] = useState();
  const [saving, setSaving] = useState(false);

  const onShow = () => {
    setAttachmentException(task.attachmentException);
    setExceptionReason(task.attachmentExceptionReason);
  };

  const attachmentUpload = <>
    <div className="fs-large">
      <FontAwesomeIcon className="me-2" icon={faPaperclip} />
      Uploaded Attachments
    </div>
    <Attachments
      attachable={{ id: task.id, type: 'Apex::Task' }}
      attachments={task.attachments}
      attachmentsPath={attachmentsPath}
      deleteEnabled={canDeleteAttachments}
      forUserId={forUserId}
      onAddAttachment={addTaskAttachment}
      onDeleteAttachment={deleteTaskAttachment}
    />
  </>;

  const exceptionReasonInput = (
    <ManagedFormGroup
      label="Exception Reason"
      name="exceptionReason"
      required
      value={exceptionReason}
      onValueChange={setExceptionReason}
    />
  );

  const handleSave = async () => {
    setSaving(true);
    await onSave({
      ...task,
      attachmentException,
      attachmentExceptionReason: showExceptionReason ? exceptionReason : '',
    });
    setSaving(false);
    onHide();
  };

  const showExceptionReason = attachmentExceptions && attachmentException && attachmentExceptionOptions.find(
    option => option.value === attachmentException
  ).hasReason;

  return (
    <Modal
      enforceFocus={false}
      show={show}
      onHide={onHide}
      onShow={onShow}
    >
      <Modal.Header closeButton>
        Attachments
      </Modal.Header>

      <Modal.Body className="d-flex flex-column gap-3">
        {attachmentExceptions && task.attachments.length === 0 && (
          <ManagedRadioGroup
            name="attachmentException"
            options={attachmentExceptionOptions}
            value={attachmentException}
            onChange={() => {}}
            onValueChange={setAttachmentException}
          />
        )}
        {showExceptionReason ? exceptionReasonInput : attachmentUpload}
      </Modal.Body>
      {showExceptionReason && (
        <Modal.Footer>
          <Button name="cancel" variant="ghost" onClick={onHide}>
            Cancel
          </Button>
          <Button disabled={!exceptionReason || saving} label="Save Task" name="save" onClick={handleSave}/>
        </Modal.Footer>
      )}
    </Modal>
  );
}

AttachmentModal.propTypes = {
  addTaskAttachment: PropTypes.func.isRequired,
  attachmentExceptions: PropTypes.bool,
  attachmentsPath: PropTypes.string.isRequired,
  canDeleteAttachments: PropTypes.bool,
  deleteTaskAttachment: PropTypes.func.isRequired,
  forUserId: PropTypes.number,
  show: PropTypes.bool,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    attachments: PropTypes.array.isRequired,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
